import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type CopyrightAgency from "./CopyrightAgency";
import type CopyrightReportFile from "./CopyrightReportFile";
import type SourceGroup from "./SourceGroup";
import type User from "./User";

enum CopyrightReportDataSet {
  activities = 1,
  audit_events = 2,
}

enum CopyrightReportType {
  itemised_report = 1,
  customer_report = 2,
  media_requests_report = 3,
  audience_activity_report = 4,
  downstream_report = 5,
  internal_summary_report = 6,
  outreach_report = 7,
  ai_summary_report = 8,
}

type CopyrightReportMedium = "online" | "print" | "magazine";

@Model()
class CopyrightReport extends ApplicationRecord {
  static jsonapiType = "copyright_reports";

  @Attr() after: string;

  @Attr() before: string;

  @Attr({ persist: false }) completedAt: string;

  @BelongsTo() copyrightAgency: CopyrightAgency;

  @Attr() copyrightAgencyId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() dataSet: CopyrightReportDataSet;

  @Attr() featureId: number;

  @HasMany() files: CopyrightReportFile[];

  @Attr() influencerGpodId: number;

  @Attr() medium: CopyrightReportMedium;

  @Attr() reportType: CopyrightReportType;

  @Attr() signedUrl: string;

  @BelongsTo() sourceGroup: SourceGroup;

  @Attr() sourceGroupId: number;

  @BelongsTo() user: User;
}

export default CopyrightReport;
